// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ContactSupport-module__container--XcLvz{display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:center;color:var(--xm-main-text-color);font-size:.625rem;line-height:1rem}.ContactSupport-module__container--XcLvz .ContactSupport-module__icon--ue0Sn{padding:.667rem;padding-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ContactSupport-module__container--XcLvz",
	"icon": "ContactSupport-module__icon--ue0Sn"
};
export default ___CSS_LOADER_EXPORT___;
